import { environment } from '../../../../environments/environment';

export const OAuthSettings = {
  validateAuthority: false,
  authority: environment.authentication.authority,
  clientID: environment.authentication.clientID,
  scopes: environment.authentication.scopes,
  graphScopes: [
    'User.Read',
    'User.Invite.All',
    'User.ReadWrite.All'
  ],
  cacheLocation: 'localStorage',
  navigateToLoginRequestUri: false,
  redirectUri:environment.authentication.redirectUri,
  postLogoutRedirectUri: environment.authentication.postLogoutRedirectUri
};



// WEBPACK FOOTER //
// ./client/app/core/auth/msal/msal.config.ts